<template>
  <v-dialog :modelValue="modelValue" max-width="560" persistent @update:modelValue="$emit('update:modelValue', $event)">
    <v-card style="border-radius: 8px; overflow: hidden">
      <v-card-title
        style="background-color: #fec627; color: #000000; font-weight: 700; padding: 20px 24px; position: relative"
      >
        <v-icon
          aria-label="Close"
          style="position: absolute; right: 16px; top: 16px; cursor: pointer; color: #000000"
          @click="close"
          >mdi-close</v-icon
        >
        <span style="font-size: 22px; line-height: 1.3; padding-right: 32px"> Self-registration isn't available </span>
      </v-card-title>

      <v-card-text style="padding: 24px; font-size: 16px; line-height: 1.6; text-align: left; color: #333333">
        <p class="mb-4">
          This is a <strong>program-supported</strong> course, so self-registration isn't available. If you'd still like
          to enroll, you can do so as a <strong>pay to enroll</strong> course.
        </p>
        <p class="mb-0">For questions about what's available in your partnership, please contact your administrator.</p>
      </v-card-text>

      <div style="padding: 0 24px 24px; display: flex; justify-content: flex-end; gap: 12px; flex-wrap: wrap">
        <UiButton variant="ghost" size="medium" @click="close">Close</UiButton>
        <UiButton variant="maroon" size="medium" data-testid="go-to-pay-to-enroll" @click="$emit('browse')">
          Browse pay to enroll courses
        </UiButton>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from 'vue';
import UiButton from './ui/Button.vue';

/**
 * ACC-389: shown when a deep-link learner lands on a program-supported (PartnerPay)
 * course they cannot self-enroll into. Styled to match OnDemandWarningModal.
 */
export default defineComponent({
  name: 'ProgramSupportedModal',
  components: { UiButton },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'browse'],
  methods: {
    close() {
      this.$emit('update:modelValue', false);
    }
  }
});
</script>
